import { authClient } from "@superadmin/utils/auth.client";
import { orpcFetch } from "@superadmin/utils/orpc.client";
import { redirect } from "react-router";

export interface AdminSession {
	user: { id: string; email: string | null; name: string };
}

/**
 * Route loader for every admin page. No session → login. A session that is
 * not on the super-admin allowlist → `/denied` (the backend `ping` gate is
 * the source of truth; nothing is decided client-side).
 */
export async function adminLoader(): Promise<AdminSession> {
	const { data: session, error } = await authClient.getSession();
	if (error || !session) throw redirect("/login");
	try {
		const res = await orpcFetch.ping({});
		return { user: res.user };
	} catch (err) {
		const code = (err as { code?: string }).code;
		if (code === "FORBIDDEN") throw redirect("/denied");
		if (code === "UNAUTHORIZED") throw redirect("/login");
		throw err;
	}
}
